export enum PadTwikeyRedirectCheckoutFlow {
  PayOnInvoice = 0,
  PayOther = 1,
  PaymentLinks = 2,
  PayOnAccount = 3,
  GuestCheckoutValidating = 4,
  GuestCheckoutNonValidating = 5,
  PaymentLinksPayOnAccount = 6,
  Wallet = 7,
}
